<template>
  <div>
    <div
      v-for="(item, index) in probes"
      :key="item.id"
      style="border-bottom: 3px solid #8D969F; margin-bottom: 20px; padding-bottom: 20px;"
    >
      <v-row>
        <v-col
          class="noYPadding"
        >
          <VTextField
            v-model="probes[index].name"
            outlined
            class="probe"
            hideDetails
            :label="$t('controller.probe.name')"
            :data-cy="`probeName-${probes[index].name}`"
            @input="updateData"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          class="noYPadding"
        >
          <VTextField
            v-model="probes[index].probeId"
            :label="$t('forms.labels.id')"
            :data-cy="`probeId-${probes[index].name}`"
            class="probe-id"
            outlined
            hideDetails
            @input="updateData"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          class="noYPadding"
        >
          <v-btn
            fab
            class="mx-2"
            xSmall
            color="red"
            @click="buttonDeleteProbe(index)"
          >
            <v-icon color="white">
              delete
            </v-icon>
          </v-btn>
          {{ $t('controller.probe.deleteProbe') }}
        </v-col>
      </v-row>
    </div>
    <v-row>
      <v-col
        class="noYPadding"
      >
        <v-btn
          fab
          class="mx-2"
          xSmall
          color="#8D969F"
          @click="buttonPlus()"
        >
          <v-icon color="white">
            add
          </v-icon>
        </v-btn>
        {{ $t('controller.probe.addProbe') }}
      </v-col>
    </v-row>
  </div>
</template>
<script>
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';

export default {
    name: 'ProbeDetail',
    components: {
        VTextField,
    },
    props: {
        controller: {
            type: Object,
            default: () => {},
        },
        editMode: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            probes: [],
        };
    },
    computed: {
        currentController() {
            return this.controller;
        },
    },
    watch: {
        probes: {
            handler() {
                this.emitChange();
                this.$emit('sendData', this.probes);
            },
            deep: true,
        },
    },
    created() {
        if (this.editMode) {
            this.probes = this.currentController.probes;
        }
        if (this?.probes?.length === 0) {
            this.probes.push({
                name: '',
                probeId: '',
                id: undefined,
            });
        }
    },
    methods: {
        updateData() {
            this.$emit('sendData', this.probes);
        },
        buttonPlus() {
            this.probes = [
                ...this.probes,
                {
                    name: '',
                    probeId: '',
                    id: undefined,
                },
            ];
        },
        probesValidate() {
            return this.probes.every(v => v.name.length > 0 && v.probeId.length > 0);
        },
        emitChange() {
            this.$emit('inputChange', this.probesValidate);
        },
        buttonDeleteProbe(index) {
            if (this.probes.length > 1) {
                this.probes.splice(index, 1);
            }
        },

    },
};
</script>
<style lang="scss" scoped>
.noYPadding {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
}
.probe {
    display: flex;
    flex-direction: column;
    width: 100%;
}
.probe-id {
    display: flex;
    flex-direction: column;
    width: 100%;
}
.text {
    font-size: 18px;
}
.float-right {
    display: flex;
}
.float-right {
    margin-top: 32px;
    .v-icon {
        width: 5px;
        height: 5px;
        padding: 15px;
    }

    .btn-icon {
        min-width: 30px;
        min-height: 30px;
        padding: 0;
    }
}
</style>
